<script lang="ts" setup>
import { PROTOCOL1, PROTOCOL2, PROTOCOL3 } from '@core/utils/constant';
</script>

<template>
  <span class="text-colorText">是否同意</span>
  <a class="!text-info hover:opacity-85" target="_blank" :href="PROTOCOL1"
    >《平台服务协议》</a
  >
  <a class="!text-info hover:opacity-85" target="_blank" :href="PROTOCOL2"
    >《平台隐私政策》</a
  >
  <a class="!text-info hover:opacity-85" target="_blank" :href="PROTOCOL3"
    >《儿童隐私保护声明》</a
  >
</template>
